import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';

import 'rxjs/add/observable/of';

import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import  {MchSeguimientoEstadoId, seguimientoEstadoEscrituraModel} from './seguimientoEstadoEscritura.model';
import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';



@Component({
	selector : 'SeguimientoEstadoEscrituras',
	templateUrl : './SeguimientoEstadoEscrituras.component.html',
    styleUrls  : ['../../../../styles.css']
})


export class SeguimientoEstadoEscriturasComponent  {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public registroEscritura;
	public guardando:boolean;
	public tercero:string;
	public displayedColumns;
	public dataSource;

	public prefijo:string;
	public contrato:string;


	public ocultar: boolean = false;
	public mensaje: string = "";
	public formularioActual: string = "";

	public seguimientoEstado:Array<seguimientoEstadoEscrituraModel>;
    


	constructor(private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar, 
		private _route: ActivatedRoute, private _router:Router,private _location: Location,
		private confirmarEliminacionService:ConfirmarEliminacionService)
	{

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
		
		this.seguimientoEstado = new Array();
		this.displayedColumns = ['fecha','cusuario','observacion','estado','id'];
		this.dataSource = new ExampleDataSource(null);
	}


	ngOnInit(){
        
		this._route.params.subscribe( params =>{
			this.registroEscritura = [{'cnumcont':params['cnumcont'], 
			'videscritura' :params['videscritura'], 
			'cprefijo' :params['cprefijo'],
			'seguimientoEstado5' :params['seguimientoEstado5']
		}];
		})
		this.cargarInfo(this.registroEscritura);
		this.dataSource = new ExampleDataSource(this.seguimientoEstado);
		this.btnAgregar = this.registroEscritura[0].seguimientoEstado5;
		if(this.registroEscritura[0].seguimientoEstado5 == 3){
			this.btnAgregar = false;
			this.formularioActual='/ConsultaDocumentacionInmuebles';

		}else if(this.registroEscritura[0].seguimientoEstado5 == 2){
			this.formularioActual='/Escritura/'+this.registroEscritura[0].cnumcont+'/'+this.registroEscritura[0].cprefijo;
		}
	}


	cargarInfo(registroEscritura){
		this.dataSource = new ExampleDataSource(null);	
		this.seguimientoEstado = new Array();
		
		this._serviciosGenerales.get('seguimientoEstadoEscritura', {cnumcont:this.registroEscritura[0].cnumcont, cprefijo:this.registroEscritura[0].cprefijo, videscritura:this.registroEscritura[0].videscritura}).subscribe(result =>{
			for(let x of result){
                this.seguimientoEstado.push(new seguimientoEstadoEscrituraModel( new MchSeguimientoEstadoId("",this.registroEscritura[0].videscritura,this.registroEscritura[0].cnumcont,this.registroEscritura[0].cprefijo),x.FECHA,x.CUSUARIO,x.OBSERVACION,x.NESTADO));                    
			};
			this.dataSource = new ExampleDataSource(this.seguimientoEstado);
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar las sucursales asociadas", "X");

		});
	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	agregar(){
		this._router.navigate(['/Escritura',
			this.registroEscritura[0].cnumcont,
			this.registroEscritura[0].videscritura,
			this.registroEscritura[0].cprefijo,		
			'insertar',2,2,2,2,2,2]);	
	}


	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}
}


export class ExampleDataSource {

	public data: Array<seguimientoEstadoEscrituraModel>;

	constructor(seguimientoEstadoEscritura:Array<seguimientoEstadoEscrituraModel>){
		this.data = new Array();
		console.log(seguimientoEstadoEscritura)
		if(seguimientoEstadoEscritura != null){
			for(let i of seguimientoEstadoEscritura){
				this.data.push(i);
			}
			console.log(this.data)
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<seguimientoEstadoEscrituraModel[]>
	{
		return Observable.of(this.data);
	}

	disconnect()
	{
	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearEscritura/SeguimientoEstadoEscrituras.component.ts